import sectionIconWithTextSliderCss from '../css-snippets/section-icon-with-text-slider';

const html = `
<style>${sectionIconWithTextSliderCss}</style>
<div class="view-icon-with-text-slider view-icon-with-text-slider-unique-id" data-id='unique-id' data-attribute="card-container" data-background="#226783" style="background-color: #226783;">
    <div class="container-page container" data-attribute="container-page" data-show-style="true">
        <div class="wrap-card">
            <div class="swiper swiperIconWithTextSlider">
                <div data-attribute="list-item" class="swiper-wrapper">
                    <div data-attribute="item" class="swiper-slide">
                        <div data-attribute="wrap-content" class="wrap-ct">
                            <div class="wrap-img">
                                <img loading="lazy" data-attribute="image-icon"
                                    src="https://cdn.skyfastimg.com/images/2025/08/29/image-68b15e6eee4c7dd3ba064ae6.webp?w=50&h=50&q=80" alt="">
                            </div>
                            <div class="wrap-text" data-attribute="text-icon">
                                Fast Shipping
                            </div>
                        </div>
                    </div>
                    <div data-attribute="item" class="swiper-slide">
                        <div data-attribute="wrap-content" class="wrap-ct">
                            <div class="wrap-img">
                                <img loading="lazy" data-attribute="image-icon"
                                    src="https://cdn.skyfastimg.com/images/2025/08/29/image-68b15e771421177f997d29f9.webp?w=50&h=50&q=80" alt="">
                            </div>
                            <div class="wrap-text" data-attribute="text-icon">
                                Payment Security
                            </div>
                        </div>
                    </div>
                    <div data-attribute="item" class="swiper-slide">
                        <div data-attribute="wrap-content" class="wrap-ct">
                            <div class="wrap-img">
                                <img loading="lazy" data-attribute="image-icon"
                                    src="https://cdn.skyfastimg.com/images/2025/08/29/image-68b15e80b21bdb90f82d9b18.webp?w=50&h=50&q=80" alt="">
                            </div>
                            <div class="wrap-text" data-attribute="text-icon">
                                24/7 Service
                            </div>
                        </div>
                    </div>
                    <div data-attribute="item" class="swiper-slide">
                        <div data-attribute="wrap-content" class="wrap-ct">
                            <div class="wrap-img">
                                <img loading="lazy" data-attribute="image-icon"
                                    src="https://cdn.skyfastimg.com/images/2025/08/29/image-68b15e8ae87eb2815f2e88dd.webp?w=50&h=50&q=80" alt="">
                            </div>
                            <div class="wrap-text" data-attribute="text-icon">
                                Money Back Guarantee
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
        </div>
    </div>
</div>
`;
export default html;
